import { gql } from "@apollo/client";

export const GET_CAPAS_PAGINATED_RECLAMOS = gql`
query allGestionCapa(
    $skip: Int
    $take: Int
    $where: GestionCapaFilterInput  
    $order: [GestionCapaSortInput!]  
) {
    allGestionCapa(skip: $skip, take: $take, where: $where, order: $order, filtroFechaVencida: 1)
    {
        items {
            idGestionCapa
            fechaApertura
            idFuenteNavigation{
                descripcion
            }
            idAreaNavigation{
                descripcion
            }
            idDelegacionNavigation{
                descripcion
            }
        }
        totalCount
    }
}`;

export const adaptCapa = (capa) => {
  return {
    idCapa: capa.idGestionCapa,
    idGestionCapa: capa.idGestionCapa,
    fechaApertura: capa.fechaApertura,
    fuente: capa.idFuenteNavigation?.descripcion,
    area: capa.idAreaNavigation?.descripcion,
    delegacion: capa.idDelegacionNavigation?.descripcion
  };
};

export const adaptCapasArray = (capas) => {
  return structuredClone(capas)?.
  map((capa) => adaptCapa(capa));
};